import { render, staticRenderFns } from "./ExamDatabaseView.vue?vue&type=template&id=25fcb5d6&"
import script from "./ExamDatabaseView.vue?vue&type=script&lang=js&"
export * from "./ExamDatabaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports